import { Route } from "react-router-dom";
import ClientListing from "../components/index";

const ClientListingRoutes = () => (
  <>
    <Route path="/client-listing" element={<ClientListing />} />
  </>
);


export default ClientListingRoutes;